import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  IonButton,
  IonItem,
  IonLabel,
  IonInput,
  IonList,
  IonCheckbox,
  IonIcon,
} from '@ionic/react';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import {
  FieldError,
  Title,
  NormalText,
  Spacer,
} from '../../components/common';
import { validateForm, forwardTo, goBack } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import { registerRequest, setGuestUser, updateProfile } from '../../store/actions';
import Basket from '../../lib/basket';
import './index.css';
import moment from '../../lib/moment';
import { chevronBack } from 'ionicons/icons';
import { getConfig } from '../../appConfig';

const { getMobile, setMobile } = Basket;

class ContactDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: this.props.profile.first_name || '',
      last_name: this.props.profile.last_name || '',
      mobile: getMobile() || this.props.profile.mobile || '',
      formErrors: {},
      guest_first_name: this.props.guestUserData.guest_first_name || '',
      guest_last_name: this.props.guestUserData.guest_last_name || '',
      guest_email: this.props.guestUserData.guest_email || '',
      guest_accepted_terms_and_conditions: true,
      guest_mobile: this.props.guestUserData.guest_mobile || '',
      guestFormErrors: {},
      guest_marketing_optin: this.props.guestUserData.guest_marketing_optin || false
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.formConfig = {
      first_name: { type: 'first_name', required: true },
      mobile: { type: 'tel', required: true },
    };
    this.guestValidationConfig = {
      guest_first_name: { type: 'first_name', required: true },
      guest_last_name: { type: 'first_name', required: true },

      guest_email: { type: 'email', required: true },

    };
  }

  componentDidMount() {
    if (this.state.first_name !== '' && this.state.mobile !== '') {
      forwardTo('/checkout', { skipContactDetails: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.profile.first_name !== prevProps.profile.first_name) {
      this.setState({ first_name: this.props.profile.first_name });
    }
    if (this.props.profile.last_name !== prevProps.profile.last_name) {
      this.setState({ last_name: this.props.profile.last_name });
    }
    if (this.props.profile.mobile !== prevProps.profile.mobile) {
      this.setState({
        mobile: this.props.profile.mobile ? this.props.profile.mobile : getMobile(),
      });
    }
  }

  handleInput = (key, val) => {
    if (key === 'mobile' || key === 'guest_mobile') {
      setMobile(val);
    }
    this.setState({ [key]: val });
  };

  handleSave() {
    const { cards } = this.props;
    let formErrors = validateForm(this.formConfig, this.state);
    this.setState({ formErrors });
    if (Object.keys(formErrors).length === 0) {
      const { first_name, last_name, mobile } = this.state;
      const profile = {
        first_name: first_name,
        last_name: last_name,
        mobile: mobile ? mobile : getMobile(),
      };
      if (mobile) {
        this.props.dispatch(updateProfile(profile, true));
        forwardTo('/checkout');
      } else {
        forwardTo('/checkout');
      }
    }
  }
  handleGuestSave = () => {
    const { dispatch } = this.props;
    let guestFormErrors;
    if (Basket.getOrderType() == 'Table' && this.state.guest_email == '') {
      const guestValidationConfigCopy = deepCopy(this.guestValidationConfig);
      delete guestValidationConfigCopy.guest_email;
      guestFormErrors = validateForm(guestValidationConfigCopy, this.state);
    } else {
      guestFormErrors = validateForm(this.guestValidationConfig, this.state);
    }
    this.setState({ guestFormErrors });
    if (Object.keys(guestFormErrors).length === 0) {
      const { guest_email, guest_first_name, guest_last_name, guest_accepted_terms_and_conditions, guest_marketing_optin } = this.state;
      const guestUserData = {
        guest_email,
        guest_first_name,
        guest_last_name,
        guest_accepted_terms_and_conditions,
        guest_marketing_optin
      };
      dispatch(setGuestUser(guestUserData));
      this.handleGuestReigister();

    }
  };

  handleGuestReigister() {
    const { registerFormData, guestUserData } = this.props;
    const timestamp = new Date().getTime();
    const { guest_email, guest_first_name, guest_last_name, guest_accepted_terms_and_conditions, guest_marketing_optin } = this.state;
    guestUserData.guest_email = this.state.email;
    let guest_email_formated = guest_email == '' || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(guest_email) ? 'guest@5loyalty.com' : guest_email;
    registerFormData.email = `${timestamp}_${guest_email_formated}`;
    registerFormData.first_name = guest_first_name;
    registerFormData.last_name = guest_last_name;

    registerFormData.accepted_terms_and_conditions = guest_accepted_terms_and_conditions;
    registerFormData.marketing_optin = guest_marketing_optin;
    registerFormData.guest = true;
    registerFormData.password = `P@ss${timestamp}!`;
    registerFormData.birthday = moment().subtract(18, 'years');

    this.props.dispatch(registerRequest({ referrer: '/checkout' }));
  }
  backHandler = () => {
    goBack();

  }
  render() {
    const { __, auth } = this.props;
    const {
      first_name,
      last_name,
      mobile,
      formErrors,
      guest_first_name,
      guest_last_name,
      guest_email,
      guestFormErrors,
      guest_marketing_optin
    } = this.state;

    return (
      <Loading transparent>
        <Layout
          showHeader
          showBack
          color="transparent" headerTitle="Contact Details" hideSecondToolbar={true}>
          <div className="absolute-content flex-row-wrapper">
            <div className='page-secondary-header' style={{ flex: 'unset' }}>
              <IonIcon onClick={() => this.backHandler()} className='page-secondary-header-back' color="gray" icon={chevronBack}></IonIcon>

              <Title className="secondary-font dark-color">{__('Contact Details')}</Title>
            </div>
            <div className="scrollable-y checkout">
              <NormalText>
                {__(
                  'To complete your order, please provide a few details in case we need to contact you',
                )}
              </NormalText>
              <Spacer size={2} />
              {this.props.auth && this.props.auth.loggedIn ? (
                <IonList>
                  <div className="input-field-container">
                    <NormalText>{__('First Name')}</NormalText>
                    <IonItem lines="none" className="input-field-wrapper">
                      <IonInput
                        onIonInput={(e) => this.handleInput('first_name', e.target.value)}
                        clearInput
                        required={true}
                        type="text"
                        pattern="text"
                        inputmode="text"
                        value={first_name}
                      ></IonInput>
                      {formErrors.first_name ? (
                        <FieldError className="field-error" value={__(formErrors.first_name)} />
                      ) : null}
                    </IonItem>
                  </div>
                  <div className="input-field-container">
                    <NormalText>{__('Last Name')}</NormalText>
                    <IonItem lines="none" className="input-field-wrapper">
                      <IonInput
                        onIonInput={(e) => this.handleInput('last_name', e.target.value)}
                        clearInput
                        required={true}
                        type="text"
                        pattern="text"
                        inputmode="text"
                        value={last_name}
                      ></IonInput>
                    </IonItem>
                  </div>

                  <div className="input-field-container">
                    <NormalText>{__('Mobile Number')}</NormalText>
                    <IonItem lines="none" className="input-field-wrapper">
                      <IonInput
                        onIonInput={(e) => this.handleInput('mobile', e.target.value)}
                        clearInput
                        required={true}
                        type="tel"
                        pattern="tel"
                        inputmode="tel"
                        value={mobile}
                      ></IonInput>
                      {formErrors.mobile ? (
                        <FieldError className="field-error" value={__(formErrors.mobile)} />
                      ) : null}
                    </IonItem>
                  </div>
                </IonList>
              ) : (
                <IonList style={{ padding: 0 }}>
                  <div className="input-field-container">
                    <IonItem lines="none" className="input-field-wrapper input-field-wrapper-colored no-border">
                      <IonInput
                        onIonInput={(e) => this.handleInput('guest_first_name', e.target.value)}
                        clearInput
                        required={true}
                        type="text"
                        pattern="text"
                        inputmode="text"
                        value={guest_first_name}
                        placeholder={__('First name')}
                      ></IonInput>
                      {guestFormErrors.guest_first_name ? (
                        <FieldError
                          className="field-error"
                          value={__(guestFormErrors.guest_first_name)}
                        />
                      ) : null}
                    </IonItem>
                  </div>
                  <div className="input-field-container">
                    <IonItem lines="none" className="input-field-wrapper input-field-wrapper-colored no-border">
                      <IonInput
                        onIonInput={(e) => this.handleInput('guest_last_name', e.target.value)}
                        clearInput
                        required={true}
                        type="text"
                        pattern="text"
                        inputmode="text"
                        value={guest_last_name}
                        placeholder={__('Last name')}
                      ></IonInput>
                      {guestFormErrors.guest_last_name ? (
                        <FieldError
                          className="field-error"
                          value={__(guestFormErrors.guest_last_name)}
                        />
                      ) : null}
                    </IonItem>
                  </div>
                  <div className="input-field-container">
                    <IonItem lines="none" className="input-field-wrapper input-field-wrapper-colored no-border">
                      <IonInput
                        onIonInput={(e) => this.handleInput('guest_email', e.target.value.trim())}
                        clearInput
                        required={true}
                        type="text"
                        pattern="text"
                        inputmode="text"
                        value={guest_email}
                        placeholder={__('Email address')}
                      ></IonInput>
                      {guestFormErrors.guest_email ? (
                        <FieldError
                          className="field-error"
                          value={__(guestFormErrors.guest_email)}
                        />
                      ) : null}
                    </IonItem>
                  </div>

                  <Spacer size={1} />
                  <div lines="none">
                    <div tabIndex="-1"></div>
                    {/* <div className="toggle">
                      <IonLabel>
                        <StrongText
                          style={{ display: 'block', marginBottom: '10px' }}
                          className="roboto-slab"
                        >
                          {__('Terms & Conditions')}
                        </StrongText>
                        <div className="register-terms-wrapper">
                          <IonCheckbox
                            color="secondary"
                            checked={guest_accepted_terms_and_conditions}
                            onIonChange={(e) =>
                              this.handleInput(
                                'guest_accepted_terms_and_conditions',
                                e.detail.checked,
                              )
                            }
                          />
                          <IonLabel className="ion-text-wrap">
                            <NormalText color="primary">
                              {__('By signing up you agree to') + ' '}{' '}
                              <span
                                className="pointer underlined secondary-color"
                                onClick={() => forwardTo('/terms')}
                              >
                                {__('our terms and conditions')}
                              </span>{' '}
                              {__('and')}{' '}
                              <span
                                className="secondary-color  pointer underlined"
                                onClick={() => forwardTo('/privacy')}
                              >
                                {__('privacy policy')}
                              </span>
                            </NormalText>
                          </IonLabel>
                        </div>
                      </IonLabel>
                      <FieldError
                        className="field-error"
                        value={__(guestFormErrors.guest_accepted_terms_and_conditions)}
                      />{' '}
                    </div> */}
                    <div lines="none">
                      <div tabIndex="-1"></div>
                      <div className="toggle">
                        <IonLabel>
                          <div className="register-terms-wrapper">
                            <IonCheckbox
                              color='secondary'
                              checked={guest_marketing_optin}
                              onIonChange={(e) =>
                                this.handleInput('guest_marketing_optin', e.detail.checked)
                              }
                            />
                            <IonLabel className="ion-text-wrap">
                              <NormalText color="primary">
                                {__(
                                  "I'd like to receive news, offers and birthday treats from Franco Manca",
                                )}
                              </NormalText>
                            </IonLabel>
                          </div>
                        </IonLabel>
                      </div>
                    </div>
                  </div>
                </IonList>
              )}
              <Spacer size={1} />
              <IonButton
                onClick={
                  this.props.auth && this.props.auth.loggedIn
                    ? this.handleSave
                    : this.handleGuestSave
                }
                color="secondary"
                expand="block"
              >
                {__('Checkout')}
              </IonButton>
              {!this.props?.auth?.loggedIn &&
                <>
                  <NormalText className="block centered" color="primary">
                    {__('By placing this order you agree to') + ' '}{' '}
                    <span className="pointer underlined secondary-color" onClick={() => getConfig().general.customTermsLink ? openExternalLink(getConfig().general.customTermsLink) : forwardTo('/terms')}>
                      {__('our terms and conditions')}
                    </span>{' '}
                    {__('and')}{' '}
                    <span className="pointer underlined secondary-color" onClick={() => getConfig().general.customPrivacyLink ? openExternalLink(getConfig().general.customPrivacyLink) : forwardTo('/privacy')}>
                      {__('privacy policy')}
                    </span>
                  </NormalText>
                </>
              }
            </div>

          </div>
        </Layout>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { auth, profile, guestUserData, registerFormData } = state.profile;
  const { cards } = state.orders;
  return {
    auth,
    profile,
    cards,
    guestUserData,
    registerFormData
  };
};

export default connect(stateToProps)(withTranslation(ContactDetails));
